import React, { useState } from "react"
import { Box, Collapse, IconButton, Typography } from "@mui/material"
import { ExpandLess, ExpandMore } from "@mui/icons-material"
import OptionTileSelector, { SVG_MAPS } from "../OptionTileSelector"

const Shape = ({
  updateOptions,
  selectedFinSetupOption,
  setSelectedFinSetupOption,
  finSetupOptions,
  selectedNoseShapeOption,
  setSelectedNoseShapeOption,
  noseShapeOptions,
  selectedTailShapeOption,
  setSelectedTailShapeOption,
  tailShapeOptions,
  selectedRockerOption,
  setSelectedRockerOption,
  rockerOptions,
  orderData,
  isStaff,
}) => {
  const [open, setOpen] = useState(true)

  const handleClick = () => {
    setOpen(!open)
  }

  return (
    <React.Fragment>
      <Box
        pt={3}
        display="flex"
        alignItems="center"
        justifyContent="center"
        sx={{ position: "relative" }}
      >
        <Typography variant="h5">Shape</Typography>
        <IconButton onClick={handleClick} sx={{ position: "absolute", right: 0 }}>
          {open ? <ExpandLess /> : <ExpandMore />}
        </IconButton>
      </Box>

      <Collapse in={open}>
        <OptionTileSelector
          isStaff={isStaff}
          orderData={orderData}
          updateOptions={updateOptions}
          title={"Nose Shape"}
          option={selectedNoseShapeOption}
          options={noseShapeOptions}
          svgMap={SVG_MAPS.nose}
        />
        <OptionTileSelector
          isStaff={isStaff}
          orderData={orderData}
          updateOptions={updateOptions}
          title={"Tail Shape"}
          option={selectedTailShapeOption}
          options={tailShapeOptions}
          svgMap={SVG_MAPS.tail}
        />
        <OptionTileSelector
          isStaff={isStaff}
          orderData={orderData}
          updateOptions={updateOptions}
          title={"Fin Setup"}
          option={selectedFinSetupOption}
          options={finSetupOptions}
          svgMap={SVG_MAPS.fin}
        />
        <OptionTileSelector
          isStaff={isStaff}
          orderData={orderData}
          updateOptions={updateOptions}
          title={"Rocker"}
          option={selectedRockerOption}
          options={rockerOptions}
          svgMap={SVG_MAPS.rocker}
        />
      </Collapse>
    </React.Fragment>
  )
}

export default Shape
